// UI Components
export { FeedbackForm } from './ui/FeedbackForm';
export { FeedbackHeaderButton } from './ui/FeedbackHeaderButton';
export { FeedbackQuickDialog } from './ui/FeedbackQuickDialog';
export { FeedbackMenuItem } from './ui/FeedbackMenuItem';
export { useQuickFeedbackStore } from './model/quick-feedback.store';
export { OnboardingModal } from './ui/OnboardingModal';

// API Service
export { supportService } from './api/support.service';

// Types
export type {
  FeedbackCategory,
  FeedbackRequest,
  FeedbackResponse,
  SupportTicketAttributes,
  SupportTicketData,
  SupportTicketRequest,
  SupportTicketResponse,
} from './types';

export {
  FEEDBACK_CATEGORIES,
  MAX_MESSAGE_LENGTH,
} from './types';
